import React from "react";
import { t } from "@/lib/i18n";
import { cn } from "@/lib/utils";

/**
 * Product wordmark — "Listed  by [DigiHome logo]".
 * The product name in Right Grotesk, a quiet "by", then the real DigiHome
 * wordmark (mark + digihome). `light` swaps to the white DigiHome wordmark for
 * ink surfaces. `byline={false}` for tight spots (mobile top bars).
 */
const SIZES = {
  sm: { name: "text-[20px]", by: "text-[10.5px]", logo: "h-[14px]" },
  md: { name: "text-[24px]", by: "text-[11px]", logo: "h-[16px]" },
  lg: { name: "text-[26px]", by: "text-[11.5px]", logo: "h-[17px]" },
  xl: { name: "text-[32px]", by: "text-[12px]", logo: "h-[20px]" },
};

export function BrandWordmark({ light = false, size = "md", byline = true, className, ...props }) {
  const s = SIZES[size] || SIZES.md;
  return (
    <span className={cn("inline-flex items-baseline gap-2", className)} data-testid="brand-wordmark" {...props}>
      <span className={cn("font-heading font-bold tracking-[-0.04em] leading-none", s.name, light ? "text-white" : "text-ink")}>{t("brand.flow")}</span>
      {byline && (
        <span className={cn("inline-flex items-center gap-1.5 leading-none", s.by, light ? "text-white/55" : "text-ink/50")} data-testid="brand-byline">
          <span className="font-medium">{t("brand.by")}</span>
          <img src={light ? "/brand/digihome-wordmark-white.svg" : "/brand/digihome-wordmark-ink.svg"} alt="DigiHome" className={cn("w-auto translate-y-[1px]", s.logo)} />
        </span>
      )}
    </span>
  );
}

/** Just the DigiHome tile — for compact places (favicons in mocks, footers). */
export function BrandMark({ className }) {
  return <img src="/brand/digihome-mark.svg" alt="DigiHome" className={cn("h-6 w-6 rounded-[6px]", className)} width={24} height={24} />;
}
